/**
 * Parses an authentication token from a cookie string.
 * @param cookieString The cookie string from request.headers.get('Cookie').
 * @param cookieName The name of the authentication cookie (e.g., 'auth_token').
 * @returns The token string if found, otherwise null.
 */
export function getAuthTokenFromCookie(
  cookieString: string | null,
  cookieName: string = "auth_token"
): string | null {
  if (!cookieString) {
    return null;
  }

  const cookies = cookieString.split(";");
  for (const cookie of cookies) {
    const parts = cookie.trim().split("=");
    const name = parts.shift(); // Get the name part
    const value = parts.join("="); // Rejoin the rest, in case value has '='

    if (name === cookieName) {
      return decodeURIComponent(value);
    }
  }

  return null;
}
